import React from "react";
import EmailInput from "./EmailInput";

type MultiEmailFieldProps = {
  id: string;
  fieldName: string;
  autofocus?: boolean;
  label?: string;
  required?: boolean;
  helperText?: string;
  className?: string;
  emailSuggestions?: string[];
  onPendingInputChange?: (value: string) => void;
};

const MultiEmailField = ({
  id,
  fieldName,
  autofocus = true,
  label = "Emails",
  required = false,
  helperText,
  className,
  emailSuggestions = [],
  onPendingInputChange,
}: MultiEmailFieldProps): React.JSX.Element => {
  return (
    <EmailInput
      name={fieldName}
      id={id}
      label={label}
      helperText={helperText}
      emailSuggestions={emailSuggestions}
      required={required}
      className={className}
      autofocus={autofocus}
      onPendingInputChange={onPendingInputChange}
    />
  );
};

export default MultiEmailField;
